module.exports = __webpack_public_path__ + "img/services-journal-v2.934d0507.svg";